import React, { useState } from "react";
import {
  useLocation,
  useNavigate,
} from "react-router-dom";

import { useTranslation } from "react-i18next";

import { useAuth } from "../auth/AuthContext";

import { auth } from "../firebase";

import { doc, getDoc, updateDoc } from "firebase/firestore";

import { db } from "../firebase";

import "./ListingUpgrade.css";

export default function ListingUpgrade() {

  const location = useLocation();

  const listingId = location.state?.listingId;

const navigate = useNavigate();

const { t } = useTranslation();

const { user } = useAuth();

const [submitting, setSubmitting] =
  useState(false);

const [days, setDays] = useState(1);

const [listing, setListing] = useState(null);

React.useEffect(() => {
  const loadListing = async () => {
    if (!location.state?.listingId) return;

    const ref = doc(db, "listings", location.state.listingId);
    const snap = await getDoc(ref);

    if (snap.exists()) {
      setListing({ id: snap.id, ...snap.data() });
    } else {
      navigate("/");
    }
  };

  loadListing();
}, [location.state?.listingId]);

if (!listing) {
  return <div>Loading listing...</div>;
}

const createPromotionPayment = async (type) => {
  try {
    const res = await fetch(
      "https://vipart-backend.onrender.com/create-payment",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type,
          userId: auth.currentUser.uid,
          listingId,
          days,
        }),
      }
    );

    const data = await res.json();

    if (data.paymentUrl) {
      window.location.href = data.paymentUrl;
    } else {
      alert("Failed to create payment");
    }
  } catch (err) {
    console.error(err);
    alert("Payment error");
  }
};

  return (

  <div className="listing-upgrade-page">

      <h1>{t("upgrade.title")}</h1>

  <p>
  {t("upgrade.subtitle")}
   </p>

<div className="days-section">

<label>  {t("upgrade.days")} </label>

<div className="days-selector">

  <span className="days-value">
   {days}
  </span>

  <div className="days-arrows">
    <button
      type="button"
      onClick={() => setDays(prev => prev + 1)}
    >
      ▲
    </button>

    <button
      type="button"
      onClick={() => setDays(prev => Math.max(1, prev - 1))}
    >
      ▼
    </button>
   </div>

 </div>
</div>


      {/* VIP CARD */}
      <div
  className="upgrade-card"
  onClick={() => createPromotionPayment("vip")}
>
  <h2> <span style={{ fontSize: "1.2em" }}>🟢</span>VIP</h2>

<p className="package-quote">
  {t("upgrade.vipQuote")}
</p>

  <p className="package-price"> 
  {t("upgrade.vipPrice")}</p>
</div>

      {/* GOLD CARD */}
      <div
  className="upgrade-card"
 onClick={() => createPromotionPayment("gold")}
>
  <h2> <span style={{ fontSize: "1.2em" }}>⭐</span>Extra VIP</h2>
  
<p className="package-quote">
  {t("upgrade.goldQuote")}
</p>

<p className="package-price"> 
   {t("upgrade.goldPrice")}</p>
</div>

      {/* EXTRA GOLD CARD */}
      <div
  className="upgrade-card"
 onClick={() => createPromotionPayment("extra_gold")}
>
  <h2> <span style={{ fontSize: "1.35em" }}>👑</span>GOLD</h2>
  
<p className="package-quote">
  {t("upgrade.extraGoldQuote")}
</p>

<p className="package-price">
  {t("upgrade.extraGoldPrice")}</p>
</div>

<button
  className="publish-standard-btn"
  onClick={async () => {
    await updateDoc(doc(db, "listings", listingId), {
      status: "published",
    });

    navigate(`/listing/${listingId}`, {
      state: { fromUploadSuccess: true },
    });
  }}
>
  {t("upgrade.standard")}
</button>

    </div>
  );
}
